/**
 * Convert a float [-1, 1] to a MIDI pan value [0, 127]
 */
export floatToPan := (f: number) ->
  if f > 0
    (f * 64) + 63
  else
    f * 64 + 64

/**
 * Convert a MIDI pan value [0, 127] to a float [-1, 1]
 */
export panToFloat := (panByte: number) ->
  if panByte > 64
    panByte += 1

  return (panByte - 64) / 64

/**
 * Convert a MIDI pitch bend value [0, 16383] to a float [-1, 1)
 */
export pitchBendToFloat := (bend: number) ->
  // normalize to [-1, 1)
  bend / 8192 - 1
